import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidenav-icon',
  templateUrl: './sidenav-icon.component.html',
  styleUrls: ['./sidenav-icon.component.scss']
})
export class SidenavIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
